import React from 'react';
import PropTypes from 'prop-types';

import { imageCdnAsset } from 'lib/common/url-helpers';

const propTypes = {
  scaleFactor: PropTypes.number,
};

const defaultProps = {
  scaleFactor: 1,
};

const scale = (coords, scaleFactor) => (coords.map(c => (c * scaleFactor)));

const NycNeighborhoods = ({ scaleFactor }) => (
  <div className="col-md-6  hidden-lte-sm">
    <picture>
      <source media="(max-width: 991px)" srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" />
      <img
        src={imageCdnAsset('/images/manhattan@2x.png')}
        width="1074" height="2114"
        useMap="#nyc-neighborhood-map"
        alt=""
      />
    </picture>
    <map name="nyc-neighborhood-map">
      <area
        alt="Upper West Side"
        title="Upper West Side"
        href="/p/upper-west-side-new-york-parking/map/"
        shape="rect"
        coords={scale([85, 192, 302, 455], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Lincoln Square"
        title="Lincoln Square"
        href="/p/lincoln-square-new-york-ny-parking/map/"
        shape="rect"
        coords={scale([84, 452, 301, 654], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Midtown West"
        title="Midtown West"
        href="/p/midtown-west-new-york-parking/map/"
        shape="rect"
        coords={scale([88, 651, 431, 792], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Times Square"
        title="Times Square"
        href="/time-square-parking/?daily=1"
        shape="rect"
        coords={scale([85, 790, 432, 904], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Garment Center"
        title="Garment Center"
        href="/p/garment-district-new-york-ny-parking/map/"
        shape="rect"
        coords={scale([84, 901, 431, 1001], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Gramercy"
        title="Gramercy"
        href="/p/gramercy-new-york-parking/map/"
        shape="rect"
        coords={scale([430, 1102, 733, 1276], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Brooklyn"
        title="Brooklyn"
        href="/p/brooklyn-parking/map/"
        shape="rect"
        coords={scale([776, 1848, 1074, 1973], scaleFactor)}
        style={{ outline: 'none' }}
      />
      <area
        alt="Queens"
        title="Queens"
        href="/p/queens-new-york-ny-parking/map/"
        shape="rect"
        coords={scale([775, 798, 1074, 905], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="The Bronx"
        title="The Bronx"
        href="/p/bronx-parking/map/"
        shape="rect"
        coords={scale([781, 38, 1060, 143], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Chelsea"
        title="Chelsea"
        href="/p/chelsea-parking/map/"
        shape="poly"
        coords={scale([90, 1002, 89, 1097, 117, 1186, 271, 1186, 282, 1187, 290, 1196, 293, 1274, 428, 1274, 426, 1003], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Midtown East"
        title="Midtown East"
        href="/p/midtown-east-new-york-parking/map/"
        shape="poly"
        coords={scale([436, 658, 438, 851, 694, 847, 691, 803, 709, 660], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Murray Hill"
        title="Murray Hill"
        href="/p/murrary-hill-new-york-parking/map/"
        shape="poly"
        coords={scale([707, 969, 631, 974, 632, 1102, 432, 1101, 434, 853, 690, 854], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Kips Bay"
        title="Kips Bay"
        href="/p/kips-bay-new-york-ny-parking/map/"
        shape="poly"
        coords={scale([716, 975, 633, 979, 632, 1105, 742, 1102, 735, 1068, 837, 1064, 845, 1047, 849, 1031, 839, 1015, 724, 1012], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Stuyvesant Town"
        title="Stuyvesant Town"
        href="/p/stuyvesant-town-parking/map/"
        shape="poly"
        coords={scale([736, 1109, 734, 1272, 858, 1274, 844, 1233, 982, 1229, 995, 1208, 988, 1180, 816, 1174], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="East Village"
        title="East Vil"
        href="/p/east-village-new-york-parking/map/"
        shape="poly"
        coords={scale([488, 1277, 485, 1314, 538, 1318, 541, 1354, 486, 1359, 487, 1438, 900, 1443, 856, 1277], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Greenwich Village"
        title="Greenwich Village"
        href="/p/greenwich-village-new-york-parking/map/"
        shape="poly"
        coords={scale([325, 1275, 326, 1361, 343, 1363, 337, 1409, 328, 1411, 328, 1444, 486, 1442, 485, 1365, 544, 1363, 543, 1317, 488, 1317, 486, 1284], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="West Village"
        title="West Village"
        href="/p/west-village-parking/map/"
        shape="poly"
        coords={scale([177, 1365, 199, 1347, 225, 1283, 321, 1284, 325, 1363, 336, 1368, 333, 1413, 325, 1415, 322, 1441, 213, 1478], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="SoHo"
        title="SoHo"
        href="/p/soho-parking/map/"
        shape="poly"
        coords={scale([213, 1483, 318, 1446, 562, 1448, 562, 1590, 244, 1592], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Lower East Side"
        title="Lower East Side"
        href="/p/lower-east-side-new-york-parking/map/"
        shape="poly"
        coords={scale([565, 1450, 899, 1448, 907, 1514, 930, 1586, 561, 1590], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Tribeca"
        title="Tribeca"
        href="/p/tribeca-parking/map/"
        shape="poly"
        coords={scale([243, 1596, 470, 1593, 471, 1858, 319, 1863, 298, 1822, 294, 1764], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Chinatown"
        title="Chinatown"
        href="/p/chinatown-new-york-parking/map/"
        shape="poly"
        coords={scale([474, 1595, 472, 1684, 661, 1741, 691, 1675, 700, 1670, 703, 1627, 692, 1623, 689, 1597], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Civic Center"
        title="Civic Center"
        href="/civic-center-parking/"
        shape="poly"
        coords={scale([473, 1688, 471, 1861, 611, 1864, 660, 1738], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Two Bridges"
        title="Two Bridges"
        href="/p/two-bridges-ny-ny-parking/map//"
        shape="poly"
        coords={scale([696, 1595, 691, 1622, 713, 1625, 712, 1671, 689, 1676, 612, 1857, 718, 1860, 774, 1803, 916, 1669, 932, 1604, 927, 1590], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Financial District"
        title="Financial District"
        href="/p/financial-district-new-york-parking/map/"
        shape="poly"
        coords={scale([316, 1859, 317, 1879, 364, 1882, 374, 1901, 373, 1915, 362, 1933, 331, 1935, 341, 1947, 339, 1965, 381, 2014, 432, 2039, 460, 2071, 484, 2078, 517, 2075, 604, 1996, 631, 1992, 672, 1955, 678, 1935, 710, 1862], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Battery Park City"
        title="Battery Park City"
        href="/p/battery-park-city-new-york-parking/map/"
        shape="poly"
        coords={scale([266, 1827, 291, 1815, 303, 1830, 316, 1881, 359, 1884, 371, 1894, 373, 1907, 365, 1926, 336, 1932, 338, 1947, 338, 1968, 313, 1976, 298, 1971, 283, 1934, 54, 1935, 41, 1922, 38, 1911, 45, 1884, 262, 1881], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Morningside Heights"
        title="Morningside Heights"
        href="/p/morningside-heights-new-york-parking/map/"
        shape="poly"
        coords={scale([85, 32, 87, 187, 294, 184, 298, 117, 337, 110, 337, 72, 303, 68, 299, 33], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="East Harlem"
        title="East Harlem"
        href="/p/east-harlem-new-york-ny-parking/map/"
        shape="poly"
        coords={scale([435, 33, 436, 177, 704, 174, 696, 123, 688, 31], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Upper East Side"
        title="Upper East Side"
        href="/p/upper-east-side-new-york-parking/map/"
        shape="poly"
        coords={scale([436, 179, 432, 646, 717, 644, 746, 493, 751, 285, 704, 180], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Central Park"
        title="Central Park"
        href="/central-park-parking/?daily=1"
        shape="poly"
        coords={scale([303, 42, 302, 64, 342, 68, 341, 109, 296, 120, 302, 648, 433, 648, 430, 35], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
      <area
        alt="Meatpacking District"
        title="Meatpacking District"
        href="/p/meatpacking-district-new-york-ny-parking/map/"
        shape="poly"
        coords={scale([22, 1192, 31, 1189, 279, 1190, 289, 1199, 291, 1267, 278, 1283, 228, 1286, 215, 1317, 207, 1321, 196, 1338, 199, 1350, 169, 1368, 135, 1289, 33, 1285, 15, 1275, 14, 1198], scaleFactor)}
        style={{ outline: 'none' }}
        target="_self"
      />
    </map>
  </div>
);

NycNeighborhoods.propTypes = propTypes;
NycNeighborhoods.defaultProps = defaultProps;
export default NycNeighborhoods;
